var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content", attrs: { "ng-init": "" } }, [
      _c("div", { staticClass: "one-register" }, [
        _c("form", [
          _c("fieldset", { staticClass: "ask_set" }, [
            _c("div", { staticClass: "one-input-container in-serach" }, [
              _c("label", { attrs: { id: "idEmail", for: "idEmail" } }, [
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm.$t("BUTTON.GLOBAL.EMAIL")) +
                    "\n                        "
                )
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email"
                  }
                ],
                attrs: {
                  id: "idEmail",
                  type: "text",
                  autocomplete: "off",
                  readonly: ""
                },
                domProps: { value: _vm.email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.email = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "one-input-container inquiryType" }, [
              _c("fieldset", { staticClass: "ui_fieldset" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inquiryType,
                        expression: "inquiryType"
                      }
                    ],
                    staticClass: "slt_white w100p",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.inquiryType = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY")) +
                          "\n                                    "
                      ),
                      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.inquiryTypeList, function(item) {
                      return _c(
                        "option",
                        {
                          key: "inquiryTypeList" + item.CODE,
                          domProps: { value: item.CODE }
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(item.CODE_NM) +
                              "\n                                "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "error-msg" }, [
                _c("div", { staticClass: "ng-hide" }, [
                  _vm._v(_vm._s(_vm.$t("MESSAGE.FIELD.INSERT.MENDATORY")))
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "model_set",
                staticStyle: { "margin-top": "30px" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "one-input-container in-serach selectModelCode"
                  },
                  [
                    _c("label", { attrs: { id: "idModel", for: "idModel" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.$t("FIELD.GLOBAL.ETC.007")) +
                          "\n                                "
                      ),
                      _c(
                        "em",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: "N" === _vm.notRelevant,
                              expression: "'N' === notRelevant"
                            }
                          ],
                          staticClass: "txt_mandatory"
                        },
                        [_vm._v("*")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectModelCode,
                          expression: "selectModelCode"
                        },
                        { name: "clearable", rawName: "v-clearable" }
                      ],
                      attrs: {
                        id: "idModel",
                        type: "text",
                        autocomplete: "off",
                        maxlength: "30",
                        readonly: _vm.notRelevant == "Y" ? true : false
                      },
                      domProps: { value: _vm.selectModelCode },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.stopPropagation()
                          return _vm.searchModelPopup($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.selectModelCode = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "in_btn_search",
                        attrs: { href: "javascript:" },
                        on: { click: _vm.searchModelPopup }
                      },
                      [
                        _c("i", { staticClass: "ico_input_serach2" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr_only" })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "error-msg" }, [
                      _c("div", { staticClass: "ng-hide" }, [
                        _vm._v(_vm._s(_vm.$t("MESSAGE.FIELD.INSERT.MENDATORY")))
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "one-checkBox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.notRelevant,
                        expression: "notRelevant"
                      }
                    ],
                    attrs: {
                      type: "checkbox",
                      id: "relevant",
                      "true-value": "Y",
                      "false-value": "N"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.notRelevant)
                        ? _vm._i(_vm.notRelevant, null) > -1
                        : _vm._q(_vm.notRelevant, "Y")
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.notRelevant,
                          $$el = $event.target,
                          $$c = $$el.checked ? "Y" : "N"
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.notRelevant = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.notRelevant = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.notRelevant = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "relevant" } }, [
                    _c("span"),
                    _vm._v(_vm._s(_vm.$t("FIELD.FAQ.NOT.RELEVANT")))
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: "N" === _vm.notRelevant,
                    expression: "'N' === notRelevant"
                  }
                ],
                staticClass: "one-input-container in-serach"
              },
              [
                _c(
                  "label",
                  { attrs: { id: "idCategory", for: "idCategory" } },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("FIELD.GLOBAL.PRODUCT.CATEGORY")) +
                        "\n                        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectProductCategory,
                      expression: "selectProductCategory"
                    }
                  ],
                  attrs: {
                    id: "idCategory",
                    type: "text",
                    autocomplete: "off",
                    readonly: ""
                  },
                  domProps: { value: _vm.selectProductCategory },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.selectProductCategory = $event.target.value
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: "Y" === _vm.notRelevant,
                    expression: "'Y' === notRelevant"
                  }
                ],
                staticClass: "one-input-container prodCateCd"
              },
              [
                _c("fieldset", { staticClass: "ui_fieldset set_2" }, [
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.prodCateCd1,
                            expression: "prodCateCd1"
                          }
                        ],
                        staticClass: "slt_white w100p",
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.prodCateCd1 = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function($event) {
                              return _vm.loadProducts("2")
                            }
                          ]
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(
                            "\n                                        " +
                              _vm._s(_vm.$t("FIELD.MAJOR.PRODUCT.CATEGORY")) +
                              "\n                                        "
                          ),
                          _c("em", { staticClass: "txt_mandatory" }, [
                            _vm._v("*")
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.prodCateCd1List, function(item) {
                          return _c(
                            "option",
                            {
                              key: "prodCateCd1List" + item.CODE,
                              domProps: { value: item.CODE }
                            },
                            [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(item.CODEDESC) +
                                  "\n                                    "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.prodCateCd2,
                            expression: "prodCateCd2"
                          }
                        ],
                        staticClass: "slt_white w100p",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.prodCateCd2 = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(
                            "\n                                        " +
                              _vm._s(_vm.$t("FIELD.SUB.PRODUCT.CATEGORY")) +
                              "\n                                        "
                          ),
                          _c("em", { staticClass: "txt_mandatory" }, [
                            _vm._v("*")
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.prodCateCd2List, function(item) {
                          return _c(
                            "option",
                            {
                              key: "prodCateCd2List" + item.CODE,
                              domProps: { value: item.CODE }
                            },
                            [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(item.CODEDESC) +
                                  "\n                                    "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "error-msg" }, [
                  _c("div", { staticClass: "ng-hide" }, [
                    _vm._v(_vm._s(_vm.$t("MESSAGE.FIELD.INSERT.MENDATORY")))
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "one-input-container in-serach title" }, [
              _c("label", { attrs: { id: "idSubject", for: "idSubject" } }, [
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm.$t("FIELD.GLOBAL.TITLE")) +
                    " "
                ),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.title,
                    expression: "title"
                  },
                  { name: "clearable", rawName: "v-clearable" }
                ],
                attrs: { id: "idSubject", type: "text", autocomplete: "off" },
                domProps: { value: _vm.title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.title = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "error-msg" }, [
                _c("div", { staticClass: "ng-hide" }, [
                  _vm._v(_vm._s(_vm.$t("MESSAGE.FIELD.INSERT.MENDATORY")))
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "one-input-container ask_textarea questionDesc" },
              [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.questionDesc,
                      expression: "questionDesc"
                    }
                  ],
                  staticClass: "textarea_ty w100p",
                  attrs: {
                    placeholder: _vm.$t("FIELD.GLOBAL.QNA.DESC") + " *"
                  },
                  domProps: { value: _vm.questionDesc },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.questionDesc = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "error-msg" }, [
                  _c("div", { staticClass: "ng-hide" }, [
                    _vm._v(_vm._s(_vm.$t("MESSAGE.FIELD.INSERT.MENDATORY")))
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "one-btn-wrap" }, [
          _c(
            "button",
            { staticClass: "bt-type-b", on: { click: _vm.goListBack } },
            [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CANCEL")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "bt-type-b blue", on: { click: _vm.save } },
            [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SUBMIT")))]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef332b3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef332b3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/voc/RequestQuestion.vue
// module id = CnIA
// module chunks = 0